import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import jwt from 'jsonwebtoken'

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';


import UsuarioService from '../../app/service/UsuarioService'
import LocalStorageService from '../../app/service/localStorageService'
import Progresso from '../../componentes/Progresso'
import { AuthContext  } from '../../main/ProvedorAutenticacao'

import '../css/util.css'
import './login.css'

import Logo from './img/ilaw-logo.png'
import capa from './img/ilawNew.png'

class Login extends React.Component {

  state = {
    email: '',
    senha: '',
    detail: '',
    classeDiv: 'hide',
    openSpinner: false,
		howModalRecuperacao: false
  }

  constructor(props) {
    super(props);
    this.service = new UsuarioService();
  }

  entrar = async () => {
    this.setState({openSpinner: true});

    await this.service.autenticar({
      email: this.state.email,
      senha: this.state.senha
    }).then(response => {
      this.context.iniciarSessao(response.data)
      this.setState({email: ''});
      this.setState({senha: ''});
      this.props.history.push('/home'); 
      this.refreshPage();
    }).catch(error => {
      if (error.message === 'Timeout') {
        this.toast.show({severity: 'error', summary: 'Autenticação', detail: 'Tempo limite de conexão excedido', life: 7000});
      } else {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Autenticação', detail:`${this.state.detail}`, life: 4000});
      }
    });
    this.setState({openSpinner: false});
  }

  refreshPage = () => {
    window.location.reload();
  }

	abrirModalRecuperacao = () => {
		this.setState({ showModalRecuperacao: true });
	}

	solicitarNovaSenha = async () => {
		if(this.state.email == '') {
			this.toast.show({severity:'error', summary: 'Recuperação de Senha', detail:'Informe o seu email de login', life: 4000});
			return;
		}

		this.setState({openSpinner: true});
		await this.service.solicitarNovaSenha(this.state.email)
			.then(response => {
				this.setState({openSpinner: false});
				this.abrirModalRecuperacao();
			}).catch(error => {
			  this.setState({ openSpinner: false });
				let mensagem = 'Ocorreu um erro inesperado. Tente novamente mais tarde.';
				if (error.response && error.response.data) {
					if (typeof error.response.data === 'string') {
						mensagem = error.response.data;
					} else if (error.response.data.message) {
						mensagem = error.response.data.message;
					} else if (error.response.data.detail) {
						mensagem = error.response.data.detail;
					}
				}
        this.toast.show({severity: 'error',summary: 'Recuperação de Senha',detail: mensagem,life: 6000});
			})
	}

	fecharModalRecuperacao = () => {
		this.setState({ showModalRecuperacao: false });
	}


  render() {
    return(
      <div className="login-page">
        <Toast ref={(el) => this.toast = el} position="top-center" />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="login-row">
          <div className="login-image-panel" style={{ backgroundImage: 'url(' + capa + ')' }}>
            <div className="login-image-overlay">
              <span className="login-image-label">iLaw Gestão Jurídica</span>
              <h2>Mais eficiência para o seu escritório</h2>
              <p>Organize processos, documentos e prazos em uma interface moderna, segura e responsiva.</p>
            </div>
          </div>
          <div className="login-card-panel">
            <div className="login-card">
              <Progresso classeSecundaria={this.state.classeDiv}/>
              <div className="login-brand">
                <img src={Logo} alt="iLaw Logo" />
              </div>
              <div className="login-description">Acesse sua conta para continuar suas atividades jurídicas com total controle.</div>
              <div className="input-group mb-3 login-input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">@</span>
                </div>
                <input type="email"
                      value={this.state.email}
                      autoComplete="nope"
                      onChange={e => this.setState({email: e.target.value})}
                      className="form-control" placeholder="E-mail"/>
              </div>

              <div className="input-group mb-3 login-input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text"><i className="fas fa-unlock-alt"></i></span>
                </div>
                <input type="password"
                      autoComplete="nope"
                      value={this.state.senha}
                      onChange={e => this.setState({senha: e.target.value})}
                      className="form-control" placeholder="Senha"/>
              </div>
              <br/>
              <div className="container-login100-form-btn">
                <button className="login100-form-btn" onClick={ this.entrar }>
                  ENTRAR
                </button>
              </div>

              <div className="login-help-row">
                <a onClick={this.solicitarNovaSenha} className="login-link" style={{cursor: 'pointer'}}>
                  Esqueceu a senha?
                </a>
              </div>
              <div className="login-footer">
                iLaw Gestão Jurídica 2022 - copyright © Goten1
              </div>
              <Modal
                open={this.state.showModalRecuperacao}
                onClose={this.fecharModalRecuperacao}
              >
                <Box className="modal-recuperacao">
                  <h2 className="modal-titulo">Recuperação de Senha</h2>
                  <p className="modal-texto">
                    Se o e-mail informado estiver cadastrado em nossa base, você receberá um link para redefinição de senha.
                  </p>
                  <Button
                    variant="contained"
                    onClick={this.fecharModalRecuperacao}
                    className="modal-botao"
                  >
                    Fechar
                  </Button>
                </Box>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
Login.contextType = AuthContext
export default withRouter (Login)